module.exports = __webpack_public_path__ + "img/logo-gradiant.18acd3b.svg";